export default __webpack_public_path__ + "static/media/photo--sm--org-1.8b843fb1.jpg";